import ModelosFeature from '../../features/modelos/ModelosFeature';

const ModelosPage = () => {
    // eslint-disable-next-line react/react-in-jsx-scope
    return <ModelosFeature />;
};

export default ModelosPage;
